import React from 'react';
import numeral from 'numeral';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { classes, Root } from './SelectionSummaryBar.styles';
import useSelectionSummary, { SelectionSummary } from '../../hooks/useSelectionSummary';

interface SelectionSummaryBarProps {
  selectedCell: ICell | undefined;
  data: ICell[][] | undefined | null;
}

const formatValue = (value: number): string => {
  if (Number.isInteger(value) && Math.abs(value) < 1e12) {
    return numeral(value).format('0,0');
  }
  return numeral(value).format('0,0.00');
};

const ITEMS: { label: string; key: keyof SelectionSummary }[] = [
  { label: 'Count', key: 'count' },
  { label: 'Sum', key: 'sum' },
  { label: 'Avg', key: 'average' },
  { label: 'Min', key: 'min' },
  { label: 'Max', key: 'max' },
];

const SelectionSummaryBar: React.FC<SelectionSummaryBarProps> = ({ selectedCell, data }) => {
  const summary = useSelectionSummary(selectedCell, data);

  if (!summary) {
    return null;
  }

  return (
    <Root className={classes.root} data-testid="selection-summary-bar">
      {ITEMS.map((item, index) => (
        <React.Fragment key={item.key}>
          {index > 0 && <span className={classes.divider}>|</span>}
          <span className={classes.item}>
            <span className={classes.label}>{item.label}:</span>
            <span className={classes.value}>{formatValue(summary[item.key])}</span>
          </span>
        </React.Fragment>
      ))}
    </Root>
  );
};

export default SelectionSummaryBar;
